export default __webpack_public_path__ + "static/vitall-white-red-full-logo-49767eb19dbbbd776a61e0ee1464ff66.svg";